import { Checkbox, CheckboxProps } from '@mui/material';

export function AdminCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      disableRipple
      sx={{
        color: 'white',
        borderRadius: '4px',
        '&.Mui-checked': {
          color: 'white',
        },
      }}
      {...props}
    />
  );
}
